module.exports = __webpack_public_path__ + "img/mobile/SmartButton/btn-bet-portrait-up@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/SmartButton/btn-bet-portrait-up@3x.png
// module id = 228
// module chunks = 0